<div class="payment-wrapper">
  @if (booking.pricing_model) {
    <div class="payment-info">
      <svg cfIcon="credit_card"></svg>
      <cf-text size="sm" class="tw:ml-1">
        @if (booking.pricing_model === EPricingModel.HOURLY) {
          {{
            "payments.pricing_model.hourly_total"
              | translate
                : {
                    price: booking.price,
                    currency_code: booking.currency_code,
                    total_price: totalPrice,
                  }
          }}
        } @else if (booking.pricing_model === EPricingModel.PER_ATTENDEE) {
          {{
            "payments.pricing_model.per_attendee_total"
              | translate
                : {
                    price: booking.price,
                    currency_code: booking.currency_code,
                    total_price: totalPrice,
                  }
          }}
        } @else {
          {{
            "payments.pricing_model.fixed_total"
              | translate
                : {
                    price: booking.price,
                    currency_code: booking.currency_code,
                  }
          }}
        }
      </cf-text>
    </div>
  }
  @if (stripeAccountConnected()) {
    <div class="payment-form mt-3">
      <cf-input-label>{{ "payments.information_label" | translate }}</cf-input-label>
      <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
        <ngx-stripe-card [options]="cardOptions" />
      </ngx-stripe-elements>
      <div class="d-flex align-items-center justify-content-center mt-1">
        <svg cfIcon="lock_filled" size="sm" class="tw:text-raven-30"></svg>
        <cf-text size="xs" class="ms-2" color="raven-40">
          {{ "payments.secured_by_stripe" | translate }}
        </cf-text>
      </div>
      @if (errorMsg) {
        <cf-input-error [message]="errorMsg"></cf-input-error>
      }
      <!--    <button class="mt-2" (click)="createToken()">create</button>-->
    </div>
  }
</div>
